import { render, staticRenderFns } from "./Dinamicos.vue?vue&type=template&id=1f4caa4c"
import script from "./Dinamicos.vue?vue&type=script&lang=js"
export * from "./Dinamicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports